export default __webpack_public_path__ + "static/nexgen-advanced-programming-a7ed4777d9f6d775bccf22bb85e1b6dc.webp";